// import Diagram from './component/Diagram';
// export default Diagram;

import Ping from "./component/Ping";
import Diagram from "./component/Diagram";

export default {
    Ping,
    Diagram
};

// import * as Options from './options.js';
// export {Options};
